import { Modal } from 'antd';
import React, { useState } from 'react';
import CategorySetting from './components/CategorySetting';
import AppSetting from './components/AppSetting';
import CustomCategory from './components/customCategory';
import styles from './index.module.less';

interface Props {
  onClose: (isRefresh: boolean) => void;
}
const TagSettingModal: React.FC<Props> = (props: Props) => {
  const { onClose } = props;
  const [currentClazz, setCurrentClazz] = useState<any>({ id: 'category' }); // category, color, designProperty
  const [isRefreshList, setIsRefreshList] = useState(false);

  const onCancel = () => {
    onClose(isRefreshList);
    setIsRefreshList(false);
  };

  return (
    <Modal
      visible={true}
      title="标签管理"
      footer={false}
      maskClosable={false}
      width={600}
      style={{ width: '600px' }}
      bodyStyle={{ padding: 0, height: 600 }}
      onCancel={onCancel}
      keyboard={false}
      wrapClassName={styles.modal}
    >
      <div className={styles.settingWrap}>
        <div className={styles.settingClass}>
          <div
            className={`${styles.clazz} ${currentClazz.id === 'category' ? styles.active : ''}`}
            onClick={() => setCurrentClazz({ id: 'category' })}
          >
            分类
          </div>
          <div
            className={`${styles.clazz} ${
              currentClazz.id === 'physicsCategory' ? styles.active : ''
            }`}
            onClick={() => setCurrentClazz({ id: 'physicsCategory' })}
          >
            物理属性
          </div>
          <div
            className={`${styles.clazz} ${currentClazz.id === 'app' ? styles.active : ''}`}
            onClick={() => setCurrentClazz({ id: 'app' })}
          >
            应用
          </div>
        </div>
        <div className={styles.settingOp}>
          {currentClazz.id === 'category' ? (
            <CustomCategory title="分类" setIsRefreshList={setIsRefreshList} />
          ) : null}
          {currentClazz.id === 'physicsCategory' ? <CategorySetting title="物理属性" /> : null}
          {currentClazz.id === 'app' ? <AppSetting title="应用" /> : null}
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(TagSettingModal);
